module.exports = __webpack_public_path__ + "a386eafaa20c90adfed5a4232a20c963.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/ja.json
// module id = 1040
// module chunks = 0